import { Snackbar } from "@material-ui/core";
import React, { useState } from "react";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import SellingService from "../../services/SellingService";
import MuiAlert from "@material-ui/lab/Alert";
import BCService from "../../services/BCService";


const SimulateRetenuAchat=({ setOnSimulate, simulateData }) => {
    const [percenteRetenu, setPercenteRetenu] = useState(0);
    const [open, setOpen] = useState(true);
    const [openAlert, setOpenAlert] = useState(false);
    const [openErrorAlert, setOpenErrorAlert] = useState(false);
    const [errorAlertText, setErrorAlertText] = useState();
    const [amountRetenuSimulated, setAmountRetenuSimulated] = useState();
  
    const handleClose = (event, reason) => {
      if (reason === "clickaway") {
        return;
      }
      setOpenAlert(false);
    };
  
    const handleEroorClose = (event, reason) => {
      if (reason === "clickaway") {
        return;
      }
      setOpenErrorAlert(false);
    };
  
    const onCancelButtonHandler = () => {
      setOpen(false);
      setOnSimulate(false);
    };
  
    const onSimulateBack = () => {
  
      BCService.retenuSimulator(
        getCurrentUserId(),
        percenteRetenu,
        simulateData.idDocument
      )
        .then((response) => {
          // setOpenAlert(true);
          setAmountRetenuSimulated(response.data.success);
        })
        .catch((e) => {
          console.log("error", e);
        });
    };
    const changePercentRetenu = (event) => {
      console.log("event", event.target.value);
      setPercenteRetenu(event.target.value);
    };
  
    function Alert(props) {
      return <MuiAlert elevation={6} variant="filled" {...props} />;
    }
  
    return (
      <>
        <div class="modal fade" id="simuler-retenu">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header bg-black">
                <h4 class="modal-title">Simuler Retenu</h4>
              </div>
              <div class="modal-body">
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label htmlFor="inputName">Pourcentage Retenu %</label>
                      <input
                        type="number"
                        min="0"
                        step="0.1"
                        class="form-control"
                        name="amount"
                        onChange={(e) => changePercentRetenu(e)}
                      />
                    </div>
                  </div>
                </div>
  
                <div className="row">
                <div className="col-sm-12">
                  <div className="form-group">
                    {amountRetenuSimulated && (
                      <label htmlFor="inputName">
                        Le montant de retenu : {amountRetenuSimulated}
                      </label>
                    )}
                  </div>
                </div>
              </div>
              </div>
  
           
              <div class="modal-footer justify-content-between">
                <button
                  type="button"
                  onClick={onCancelButtonHandler}
                  class="btn btn-light"
                  data-dismiss="modal"
                >
                  Close
                </button>
  
                <button
                  type="button"
                  onClick={onSimulateBack}
                  class="btn btn-light"
                >
                  Confirmer
                </button>
              </div>
            </div>
          </div>
        </div>
  
        <Snackbar
          open={openAlert}
          autoHideDuration={2000}
          onClose={handleClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert onClose={handleClose} severity="success">
            Ajout avec success !
          </Alert>
        </Snackbar>
  
        <Snackbar
          open={openErrorAlert}
          autoHideDuration={4000}
          onClose={handleEroorClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert onClose={handleEroorClose} severity="error">
            {errorAlertText}
          </Alert>
        </Snackbar>
      </>
    );



}
export default SimulateRetenuAchat;
